/**
 * Создает функцию логирования для аналитики.
 *
 * @param {object} options - опции функции логирования
 * @param {string} options.styles - стили функции логирования для `console.log`
 * @param {string} options.loggerPrependMessage - сообщение в начале
 * @param {boolean} options.debug - флаг отладки. Если `false`, то возвращает пустую функцию.
 * @returns {Function} функция логирования
 */
export const buildAnalyticsLogger = ({
  styles,
  loggerPrependMessage,
  debug,
}) => {
  if (!debug) {
    return () => {}
  }

  return console.log.bind(console, loggerPrependMessage, styles)
}
